import { createStandardAction, createAsyncAction } from 'typesafe-actions'
import {
  GetReportListReq,
  GetReportListResp,
  Filter,
  GetReportDetailReq,
  GetReportDetailResp,
} from './types'

export const getReportListAction = createAsyncAction(
  'admin/report/commonarea/GET_LIST_REQ',
  'admin/report/commonarea/GET_LIST_RESP',
  'admin/report/commonarea/GET_LIST_FAIL'
)<GetReportListReq, GetReportListResp, any>()

export const getReportDetailAction = createAsyncAction(
  'admin/report/commonarea/GET_DETAIL_REQ',
  'admin/report/commonarea/GET_DETAIL_RESP',
  'admin/report/commonarea/GET_DETAIL_FAIL'
)<GetReportDetailReq, GetReportDetailResp, any>()

export const updateFilter = createStandardAction(
  'admin/report/commonarea/UPDATE_FILTER_ACTION'
)<Filter, void>()

export const clearFilter = createStandardAction(
  'admin/report/commonarea/CLEAR_FILTER_ACTION'
)<void>()

export const sortingTask = createStandardAction(
  'admin/report/commonarea/SORTING'
)<{
  name: string
  sort?: string
}>()

export const exportReportListAction = createAsyncAction(
  'admin/report/commonarea/EXPORT_LIST_REQ',
  'admin/report/commonarea/EXPORT_LIST_RESP',
  'admin/report/commonarea/EXPORT_LIST_FAIL'
)<GetReportListReq, GetReportListResp, any>()
